<template>
  <div>
    <v-card :class="classSection" :height="cardHeight">
      <v-card-title>
        <v-avatar :class="classAvatar" size="56">
          <img src="@/assets/diagram.svg" />
        </v-avatar>
        <span class="title font-weight-light">Expenses</span>
        <span class="subtitle-2 font-weight-light ml-1 mt-1">(non chargeables)</span>
        <v-spacer></v-spacer>
        <ActionFabButton :cb="() => showDialog('expenses', null)" />
      </v-card-title>
      <div class="section-line"></div>
      <div v-if="selectedProject.expenses.length == 0" class="pa-2">
        <span class="body-2 font-weight-light ml-3">No items</span>
      </div>
      <div :style="scrollAreaHeight">
        <v-card
          :class="classInnerSection"
          outlined
          v-for="(expense) in getOrderedProjectItems('expenses')"
          :key="expense.exid"
        >
          <v-card-text :class="classInnerRow" @click="showDialog('expenses', expense)">
            <div class="d-flex flex-row">
              <span class="body-1 font-weight-medium">{{ formatDate(expense.date) }}</span>
              <span
                v-if="expense.wiid"
                class="body-2 ml-3 deep-purple--text"
              >[{{ getWorkitemName(expense.wiid) }}]</span>
              <v-spacer></v-spacer>
              <span class="subtitle-2 mr-0 text-right">{{ formatNumber(expense.value) }}</span>
            </div>
            <div class="d-flex flex-row">
              <span class="subtitle-2 font-weight-light">{{ expense.description }}</span>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="showingDialog" scrollable max-width="350px">
        <DialogProjectExpenseItem :obj="objToDialog" />
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import ActionFabButton from "@/components/ActionFabButton";
import { section_Shared } from "./section_Shared";
import { section_Layout } from "./section_Layout";
import { section_Formatting } from "./section_Formatting";
import { section_Dialog } from "./section_Dialog";
import DialogProjectExpenseItem from "@/components/dialogs/sections/DialogProjectExpenseItem";

export default {
  name: "SectionWorkItems",
  components: { ActionFabButton, DialogProjectExpenseItem },

  setup(props, context) {
    return {
      ...section_Dialog(context),
      ...section_Layout(context),
      ...section_Shared(context),
      ...section_Formatting(),
    };
  },
};
</script>

<style>
</style>